<script>
export default {
	props: {
		myId: {
			type: String,
			required: true
		}
	},
}
</script>
<template>
	<b-modal :id="myId" class="follow-modal" hide-footer>
		<div class="head">
			{{ $t('group.members') }}
		</div>
		<div class="follow-panel">
			<slot />
		</div>
	</b-modal>
</template>

<style lang="scss" scoped>
.head {
	padding: 10px $size-pd;
	border-bottom: 1px solid $color-primary-bd;
	font-size: 16px;
  color: #282828;
  font-weight: 500;
  @include media-breakpoint-down(md) {
		padding: $size-pd-inner-sp;
	}
}
.follow-panel {
	max-height: 300px;
	overflow: auto;
}
/deep/ {
	.modal-dialog {
		margin: 25vh auto 0;
		@include media-breakpoint-down(md) {
			width: 90%;
		}
	}
	.modal-header {
		padding: 0;
    border: 0;
    position: absolute;
    right: 1rem;
    top: 5px;
    z-index: 99;
    .close {
	   	font-size: 32px;
	   }
	}
	.modal-body {
		padding: 0 0 $size-pd;
		@include media-breakpoint-down(md) {
			padding: 0 0 $size-pd-inner-sp;
		}
	}
	.follow-item {
		padding: 0 $size-pd;
		margin-top: 15px;
		@include media-breakpoint-down(md) {
			padding: 0 $size-pd-inner-sp;
		}
	}
}
</style>
